import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { format } from 'date-fns'

import { SERIES_CONFIG } from '../../../constants'
import styles from './coming-soon-badge.css'

function ComingSoonBadge({
  startDate, mobile, isDetailLayout, isRental
}) {
  const availableDateShort = mobile ? format(new Date(startDate), 'MMM do') : format(new Date(startDate), 'MMMM do')
  const availableDateLong = format(new Date(startDate), 'd MMMM yyyy')

  return (
    <div
      className={classNames(
        {
          [styles.upcomingEpisode]: !isDetailLayout,
          [styles.upcomingTitle]: isDetailLayout,
          [styles.isRental]: isRental
        }
      )}
    >
      <div
        className={classNames(
          {
            [styles.comingSoon]: !isDetailLayout,
            [styles.comingSoonTitle]: isDetailLayout,
            [styles.isRental]: isRental
          },
          styles.status
        )}
      >
        {SERIES_CONFIG.comingSoonEpisode}
      </div>
      {
        isDetailLayout
          ? (
            <span className={classNames(styles.startDateTitle, {
              [styles.isRental]: isRental
            })}
            >
              <span className={styles.available}>Available&nbsp;</span>
              {availableDateLong}
            </span>
          )
          : <span className={styles.startDate}>{availableDateShort}</span>
      }
    </div>
  )
}

ComingSoonBadge.propTypes = {
  startDate: PropTypes.string.isRequired,
  mobile: PropTypes.bool,
  isDetailLayout: PropTypes.bool,
  isRental: PropTypes.bool
}
ComingSoonBadge.defaultProps = {
  mobile: false,
  isDetailLayout: false,
  isRental: false
}

export default ComingSoonBadge
